import { Company, EntityLabel, Group } from '@esg/esg-global-types';

export interface CompanyExtended extends Company {
  group: Group;
}

// Singular and plural label for model entity.
export const company_label: EntityLabel = {
  one: 'Company',
  many: 'Companies'
};
